import React from 'react';

const VisitedProductPage = () => <></>;

export default VisitedProductPage;
